import React from 'react';

import MuiCard, { CardProps as MuiCardProps } from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';

export type CardProps = MuiCardProps;

export const Card = (props: CardProps): JSX.Element => {
  const { children, onClick, ...rest } = props;
  const onClickProp = onClick && { onClick };

  return (
    <MuiCard {...onClickProp} {...rest}>
      {onClick ? (
        <CardActionArea data-fd="card-action-area">{children}</CardActionArea>
      ) : (
        children
      )}
    </MuiCard>
  );
};
